import { contactInfo } from '@/mocks/homeData';

export default function Contact() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-primary-500">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-background-50/20 text-background-50 mx-auto lg:mx-0 mb-5">
              <i className="ri-mail-send-line text-2xl"></i>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">
              {contactInfo.title}
            </h2>
            <p className="text-sm md:text-base text-background-50/80 font-body mb-2">
              {contactInfo.subtitle}
            </p>
            <p className="text-xs md:text-sm text-background-50/60 font-body leading-relaxed max-w-xl">
              {contactInfo.description}
            </p>
          </div>
          <div className="flex flex-col sm:flex-row items-center gap-4 lg:shrink-0">
            <div className="flex flex-col items-center gap-2 p-6 rounded-xl bg-background-50/10 border border-background-50/20 min-w-[180px]">
              <i className="ri-wechat-line text-3xl text-background-50"></i>
              <span className="text-sm font-medium text-background-50 font-label">微信爆料</span>
              <span className="text-xs text-background-50/60 font-mono tracking-wider">
                whhl_666
              </span>
            </div>
            <div className="flex flex-col items-center gap-2 p-6 rounded-xl bg-background-50/10 border border-background-50/20 min-w-[180px]">
              <i className="ri-mail-line text-3xl text-background-50"></i>
              <span className="text-sm font-medium text-background-50 font-label">邮件投稿</span>
              <span className="text-xs text-background-50/60 font-mono tracking-wider">
                tips@whhl.com
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}